import { map } from 'rxjs/operators';
import { Component, Input, OnInit, Inject, SimpleChanges } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import * as uuid from 'uuid';
import { CurrencyPipe, DOCUMENT } from '@angular/common';
import { MarkerClusterer } from "@googlemaps/markerclusterer";
import { IListing } from '@clooper/core';
import { IBooking } from 'projects/clooper/core/src/public-api';

@Component({
  selector: 'app-total-trips-map-view',
  templateUrl: './total-trips-map-view.component.html',
  styleUrls: ['./total-trips-map-view.component.scss'],
  providers: [CurrencyPipe],

})
export class TotalTripsMapViewComponent {
  @Input() data: any[] = []
  listings: IListing[]
  employees: any
  bookings: IBooking[]

  constructor(
  ) {

  }

  ngOnInit(): void {
    this.setMapData(this.data)

  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data.previousValue !== changes.data.currentValue) {
      this.setMapData(changes.data.currentValue)
    }
  }

  setMapData(data: any[]) {
    this.listings = data?.map((data: any) => {
      return data.booking?.listing
    })
    this.employees = data?.map((data: any) => {
      return data.employee
    })
    this.bookings = data?.map((data: any) => {
      return data.booking
    })
  }


}
